import * as types from '@/store/mutation-types';

const state = {
  storeOrdersLoaded: false,
  storeOrders: [],
};

const getters = {
  storeOrdersLoaded(state) {
    return state.storeOrdersLoaded;
  },
  storeOrders(state) {
    return state.storeOrders;
  },
};

const mutations = {
  [types.SET_ORDERS_LOADED](state, p) {
    state.storeOrdersLoaded = p;
  },
  [types.SET_STORE_ORDERS](state, orders) {
    state.storeOrders = orders;
  },
};

const actions = {
  setOrdersLoaded: ({ commit }, p) => {
    commit(types.SET_ORDERS_LOADED, p);
  },
  setStoreOrders: ({ commit }, p) => {
    commit(types.SET_STORE_ORDERS, p);
  },
};

export default {
  actions,
  mutations,
  state,
  getters,
};



// WEBPACK FOOTER //
// ./src/global-view/editor/page/top-control-bar/dynamic-data/store/orders/vuex.js